import { useState } from "react";
import style from "./newExternalAddress.module.css";
import AddressForm from "./components/AddressForm";
import { yupResolver } from "@hookform/resolvers/yup";
import formSchema from "./utility/formSchema";
import { Modal, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import doSubmit from "./functions/doSubmit";

function NewExternalAddress({ close, set }) {
  const [personType, setPersonType] = useState(0);
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    register,
    unregister,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema(personType)),
  });

  return (
    <Modal show={true} size="xl" centered={true} className={style.modal}>
      <form
        onSubmit={handleSubmit(values => {
          setLoading(true);
          doSubmit(
            { ...values, type: personType },
            () => {
              setLoading(false);
            },
            set,
            close
          );
        })}
      >
        <Modal.Header>
          <h5>ثبت آدرس خارجی</h5>
        </Modal.Header>
        <Modal.Body>
          <div className={style.header}>
            <button
              type="button"
              className={
                "nav-link" + (personType === 0 ? " " + style.active : "")
              }
              onClick={() => setPersonType(0)}
            >
              حقیقی
            </button>
            <button
              type="button"
              className={
                "nav-link" + (personType === 1 ? " " + style.active : "")
              }
              onClick={() => setPersonType(1)}
            >
              حقوقی
            </button>
          </div>
          <AddressForm
            personType={personType}
            errors={errors}
            register={register}
            control={control}
            unregister={unregister}
          />
        </Modal.Body>
        <Modal.Footer>
          {loading === true ? (
            <button className="btn btn-success" type="button">
              <div className="d-flex align-items-center">
                <Spinner
                  style={{
                    width: "20px",
                    height: "20px",
                    fontSize: "0.8rem",
                  }}
                />
                <span className="me-1"> در حال ثبت</span>
              </div>
            </button>
          ) : (
            <button className="btn btn-success" type="submit">
              ثبت
            </button>
          )}

          <button className="btn btn-danger" type="button" onClick={close}>
            بستن
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default NewExternalAddress;
